import OntosError from '../../model/OntosError'
import { CredentialError } from "@/errors/errors"
import { t } from "@/i18n"

export default {
    //Os eventos que os hooks abaixo emitem. Ver o comentário gêmeo no RouteComponent:
    //sem isto o Vue 3 trata cada um como listener nativo e avisa a cada emissão.
    emits: ['loaded', 'showMessage', 'showErrorMessage'],
    data() {
        return {
            loaded: false,
            isSaving: false,
            isLoading: true
        }
    },

    computed: {
        baseProps(): { loading: boolean; saving: boolean } {
            return {
                loading: (this as any).isLoading,
                saving: (this as any).isSaving
            }
        }
    },

    async mounted() {
        const before = new Date()
        const self = this as any
        self.isLoading = true
        try {
            if (self.load) {
                const load = self.load()
                await load
            }
            self.loaded = true
            self.$emit('loaded')
        } catch (err: any) {
            if (err instanceof CredentialError) await self.$router.push({ name: 'login' })
            else {
                self.$emit('showErrorMessage', err.message)
            }
            console.error(err)
        } finally {
            console.info(`Load time for ${JSON.stringify(self.$route.name)} = ${Number(new Date()) - Number(before)}`)
            self.isLoading = false
        }
    },

    errorCaptured(err: Error) {
        if (err.name === 'OntosError') {
            (this as any).$emit('showErrorMessage', err.message)
            console.error(err)
        } else {
            try {
                throw new OntosError(t('error.unexpected-report'), err)
            } catch (err: any) {
                console.error(err)
                ;(this as any).$emit('showErrorMessage', err.message)
            }
        }
    },

    methods: {
        info(message: string) {
            (this as any).$emit('showMessage', message)
        },

        throwError(err: string, cause?: Error) {
            throw new OntosError(err, cause)
        },

        async saving(fun: () => Promise<any>) {
            try {
                (this as any).isSaving = true
                return await fun()
            } finally {
                (this as any).isSaving = false
            }
        }
    }
}
